import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Message } from 'primereact/message';

const ConsentCheckbox = ({ 
    checked, 
    onChange, 
    error,
    reportType = 'report',
    customText = null 
}) => {
    const defaultConsentText = {
        'equifax': "I have obtained the applicant's explicit consent for accessing their Equifax Credit Report. The applicant has authorized the retrieval of their credit information from Equifax Credit Bureau for assessment purposes.",
        'bank-statement': "I have obtained the applicant's explicit consent for accessing their Bank Statement Analysis. The applicant has authorized the analysis of their bank statement data for financial assessment purposes.",
        'pan': "I have obtained the applicant's explicit consent for accessing their PAN Verification Report. The applicant has authorized the verification of their PAN details with the Income Tax Department.",
        'voter-id': "I have obtained the applicant's explicit consent for accessing their Voter ID Verification Report. The applicant has authorized the verification of their Voter ID details with the Election Commission.",
        'employment': "I have obtained the applicant's explicit consent for accessing their Employment History Report. The applicant has authorized the verification of their employment history and details.",
        'driving-licence': "I have obtained the applicant's explicit consent for accessing their Driving License Verification Report. The applicant has authorized the verification of their driving license details with the Transport Department.",
        'ehf-uan': "I have obtained the applicant's explicit consent for accessing their EPF/UAN Verification Report. The applicant has authorized the verification of their EPF/UAN details from the EPFO database.",
        'gstin': "I have obtained the applicant's explicit consent for accessing their GSTIN Advanced Verification Report. The applicant has authorized the retrieval of their GST registration details from the GSTN database.",
        'default': `I have obtained the applicant's explicit consent for accessing their ${reportType} report. The applicant has authorized this verification and I confirm that all information provided is accurate and complete.`
    };

    const consentText = customText || defaultConsentText[reportType] || defaultConsentText['default'];

    return (
        <div className="field col-12">
            <div className="p-3 surface-100 border-round-md">
                <div className="flex align-items-start gap-2">
                    <Checkbox 
                        inputId="consent-checkbox"
                        checked={checked}
                        onChange={onChange}
                        className={error ? 'p-invalid' : ''}
                    />
                    <label 
                        htmlFor="consent-checkbox" 
                        className="text-sm cursor-pointer flex-1"
                        style={{ lineHeight: '1.5' }}
                    >
                        {consentText}
                    </label>
                </div>
                {error && (
                    <Message 
                        severity="error" 
                        text="Please provide your consent to proceed" 
                        className="mt-2 w-full"
                        style={{ fontSize: '0.875rem' }}
                    />
                )}
            </div>
        </div>
    );
};

export default ConsentCheckbox;